import authorizationHeader from "#shared/utils/authorizationHeader";
import httpClient from "../utils/httpClient/httpClient";

const getConfig = async () => {
    if (!strapi) {
        throw new Error(
            'Strapi instance is required to get config',
        );
    }

    const strapiBackendURL = strapi?.backendURL.length
        ? strapi.backendURL
        : window.location.origin;
    try {
        const response = await httpClient.get(
            `${strapiBackendURL}/courses/get-config`,
            {
                headers: {
                    ...authorizationHeader,
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    } catch (error) {
        return error.data;
    }
};

export default getConfig;
